var React = require('react');

function O1 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"O1"),React.createElement("path",{"d":"M81.85,40.42A40.92,40.92,0,0,0,40.43,0h0V0q-2.07,0-4.08.25a40.93,40.93,0,0,0,5.09,81.59v0q2.07,0,4.08-.25A40.93,40.93,0,0,0,81.85,40.42Z","fill":"#73c9bd","key":1})]);
}

O1.defaultProps = {"viewBox":"0 0 81.85 81.85"};

module.exports = O1;

O1.default = O1;
